/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import { Modal, Box, Grid, Tooltip, Button, Divider } from '@mui/material';
import $ from 'jquery';

import { closeIconBlack } from '../../shared/assets/images';
import './ro.scss';
import { output_data } from './rodg-output';
import UIGrid from '../uigrid';
import { convertUnitValues_flux, convertUnitValues_flow } from '../../shared/conversion-helper/unitConversion';

const feed_water_params = [...output_data.ro_elements_DG];
const system_params_props = [
  {
    hdata: 'Name',
    tag: 'parameters',
    datatype: 'text',
    disabled: ''
  }, {
    hdata: 'Name',
    tag: 'condition',
    datatype: 'text',
    disabled: true
  },
  {
    hdata: 'unit',
    tag: 'unit',
    disabled: '',
    datatype: 'select',
  },
  {
    hdata: 'RO Permeate',
    tag: 'RO Permeate',
    datatype: 'text',
    disabled: true
  },
  {
    hdata: 'Brackish Wellwater',
    tag: 'Brackish Wellwater',
    datatype: 'text',
    disabled: true
  },
  {
    hdata: 'Brackish Surfacewater (MF/UF)',
    tag: 'Brackish Surfacewater (MF/UF)',
    datatype: 'text',
    disabled: true
  },
  {
    hdata: 'Brackish Surfacewater (Conventional)',
    tag: 'Brackish Surfacewater (Conventional)',
    datatype: 'text',
    disabled: true
  },
  {
    hdata: 'Sea Wellwater',
    tag: 'Sea Wellwater',
    datatype: 'text',
    disabled: true
  },
  {
    hdata: 'Surface Seawater (MF/UF)',
    tag: 'Surface Seawater (MF/UF)',
    datatype: 'text',
    disabled: true
  },
  {
    hdata: 'Surface Seawater (Conventional)',
    tag: 'Surface Seawater (Conventional)',
    datatype: 'text',
    disabled: true
  },
  {
    hdata: 'Tertiary Treated Wastewater (MF/UF)',
    tag: 'Tertiary Treated Wastewater (MF/UF)',
    datatype: 'text',
    disabled: true
  },
  {
    hdata: 'Tertiary Treated Wastewater (Conventional)',
    tag: 'Tertiary Treated Wastewater (Conventional)',
    datatype: 'text',
    disabled: true
  },
  {
    hdata: 'MBR Permeate',
    tag: 'MBR Permeate',
    datatype: 'text',
    disabled: true
  }
];
const iteration_params = system_params_props.slice(3, 16).map((d) => d.hdata);
feed_water_params.map((d) => {
  iteration_params.forEach((v) => {
    d[`${v}_PV`] = d[v];
  });
});
function DesignGildelines(props) {
  const { visibleDG, handleCloseDG, translateObject } = props;
  const Units = [...output_data.units];
  const fluxUnits = Units[2].unit;
  const flowUnits = Units[8].unit;
  const checkCustomHeader = true;
  const headerData = [[...output_data.firstHeader], [...output_data.secoundHeader], [...output_data.thirdHeader]];
  const [design_params, setDesign_parms] = useState([]);
  const [, setPreFlow] = useState('gpm');
  const [, setPreFlux] = useState('gfd');
  const handelUnitChanges = (e) => {
    let presentVal = '';
    const targetValue = e.target ? e.target.value : e;
    // eslint-disable-next-line no-nested-ternary
    presentVal = flowUnits.includes(targetValue) ? 'flow' : (fluxUnits.includes(targetValue) ? 'flux' : '');
    feed_water_params.map((d) => {
      if (d.condition === 'Typical Range' && presentVal === 'flux') {
        if (targetValue === 'm/s') {
          iteration_params.forEach((v) => {
            d[`${v}_2`] = (d[`${v}_PV`]).split('-');
            d[`${v}_3`] = parseFloat(convertUnitValues_flux((d[`${v}_2`][0]), 'gfd', targetValue));
            d[`${v}_4`] = parseFloat(convertUnitValues_flux((d[`${v}_2`][1] ? d[`${v}_2`][1] : d[`${v}_2`]), 'gfd', targetValue));
            d[`${v}_1`] = `${d[`${v}_3`]}-${d[`${v}_4`]}`;
            d[v] = `${(d[`${v}_3`]).toExponential(0)}-${(d[`${v}_4`]).toExponential(0)}`;
          });
          d.unit = targetValue;
        } else {
          iteration_params.forEach((v) => {
            d[`${v}_2`] = (d[`${v}_PV`]).split('-');
            d[`${v}_3`] = parseFloat(convertUnitValues_flux((d[`${v}_2`][0]), 'gfd', targetValue));
            d[`${v}_4`] = parseFloat(convertUnitValues_flux((d[`${v}_2`][1] ? d[`${v}_2`][1] : d[`${v}_2`]), 'gfd', targetValue));
            d[`${v}_1`] = `${d[`${v}_3`]}-${d[`${v}_4`]}`;
            if (targetValue === 'm/hr') {
              d[v] = `${(d[`${v}_3`]).toFixed(2)}-${(d[`${v}_4`]).toFixed(2)}`;
            } else {
              d[v] = `${(d[`${v}_3`]).toFixed(0)}-${(d[`${v}_4`]).toFixed(0)}`;
            }
          });
          d.unit = targetValue;
        };
      } else {
        if (targetValue === 'm/s' || targetValue === 'm3/s') {
          if (d.unitType === presentVal && presentVal === 'flow') {
            iteration_params.forEach((v) => {
              d[`${v}_1`] = parseFloat(convertUnitValues_flow((d[`${v}_PV`]), 'gpm', targetValue));
              d[v] = (targetValue === 'gpm') ? (d[`${v}_PV`]) : (+d[`${v}_1`]).toExponential(2);
            });
            d.unit = targetValue;
          };
          if (d.unitType === presentVal && presentVal === 'flux') {
            iteration_params.forEach((v) => {
              d[`${v}_1`] = parseFloat(convertUnitValues_flux((d[`${v}_PV`]), 'gfd', targetValue));
              d[v] = (targetValue === 'gfd') ? (d[`${v}_PV`]) : (+d[`${v}_1`]).toExponential(2);
            });
            d.unit = targetValue;
          };
        } else {
          if (d.unitType === presentVal && presentVal === 'flow') {
            iteration_params.forEach((v) => {
              d[`${v}_1`] = parseFloat(convertUnitValues_flow((d[`${v}_PV`]), 'gpm', targetValue));
              d[v] = (targetValue === 'gpm') ? (d[`${v}_PV`]) : (+d[`${v}_1`]).toFixed(2);
            });
            d.unit = targetValue;
          };
          if (d.unitType === presentVal && presentVal === 'flux') {
            iteration_params.forEach((v) => {
              d[`${v}_1`] = parseFloat(convertUnitValues_flux((d[`${v}_PV`]), 'gfd', targetValue));
              d[v] = (targetValue === 'gfd') ? (d[`${v}_PV`]) : (+d[`${v}_1`]).toFixed(2);
            });
            d.unit = targetValue;
          };
        };
      }
    });
    if (presentVal === 'flux') {
      setPreFlux(targetValue);
    };
    if (presentVal === 'flow') {
      setPreFlow(targetValue);
    };
    setDesign_parms(feed_water_params);
  };
  useEffect(() => {
    const previousUnits = { 'preFlow': 'gpm', 'preFlux': 'gfd' };
    localStorage.setItem('previousUnits', JSON.stringify(previousUnits));
    const values = JSON.parse(localStorage.getItem('unit_set_dict'));
    const sysUnitFlux = values ? values.Flux : 'gfd';
    const sysUnitFlow = values ? values['Volume Flow'] : 'gpm';
    handelUnitChanges(sysUnitFlux);
    handelUnitChanges(sysUnitFlow);
  }, []);
  setTimeout(() => {
    $('.design_guileliens .cell_1_3 .react-contextmenu-wrapper').html('');
    $('.design_guileliens .cell_2_1, .design_guileliens .cell_5_1').attr('rowspan', 2);
    $('.design_guileliens .cell_3_1, .design_guileliens .cell_6_1, .design_guileliens .cell_10_1, .design_guileliens .cell_11_1').remove();
    $('.design_guileliens .cell_15_1, .design_guileliens .cell_16_1, .design_guileliens .cell_12_1, .design_guileliens .cell_14_1').remove();
    $('.design_guileliens .cell_9_1, .design_guileliens .cell_13_1').attr('rowspan', 4);
    $('.design_guileliens .cell_5_3 .react-contextmenu-wrapper, .design_guileliens .cell_6_3 .react-contextmenu-wrapper').html('%');
    $('.design_guileliens .cell_7_3 .react-contextmenu-wrapper, .design_guileliens .cell_8_3 .react-contextmenu-wrapper').html('%');
  }, 1);

  return (
    <Draggable handle='.rodg-box'
      cancel='.rodg-header-text, .content-tab-title, .rodg-content-grid, .MuiButton-contained'
      onStart={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}>
      <Modal
        hideBackdrop
        open={visibleDG}
        onClose={handleCloseDG}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        className="rodg-modal"
      >
        <Box className='rodg-box'>
          <Grid container className='rodg-grid-container'>
            <Grid item xs={12}>
              <Grid item xs={12} className='rodg-header-grid'>
                <div className='rodg-header-text rufusBld'>{translateObject('Design Guidelines')}</div>
                <div className='rodg-close-icon'>
                  <Tooltip title="Close">
                    <img
                      src={closeIconBlack}
                      alt="close"
                      onClick={handleCloseDG}
                      style={{ width: '14px', padding: '11px' }}
                      className="pointer"
                    />
                  </Tooltip>
                </div>
              </Grid>
              <Grid id='rodgCont'>
                <h5><span id='rodgTitletxt' className="content-tab-title rufusBld">
                  {translateObject('Winflows Design Simulator RO Elements Design Guidelines')}</span></h5>
                <Grid item xs={12} className='rodg-content-grid'>
                  <UIGrid
                    data={design_params}
                    properties={system_params_props}
                    checkCustomHeader={checkCustomHeader}
                    headerData={headerData}
                    options={Units}
                    onchange={handelUnitChanges}
                    tableClassName='design_guileliens'
                  />
                </Grid>
              </Grid>
              <Divider />
              <Grid item xs={12} className='rodg-footer-grid float-r'>
                <Button
                  id='rodgOkBtn'
                  size="small"
                  variant="contained"
                  className="sansW4SeLig M_Bold"
                  onClick={handleCloseDG}
                  style={{ width: '120px', fontSize: '16px' }}>
                  {translateObject('OK')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Draggable>
  );
}

export default DesignGildelines;
